import { equals, uniqWith } from "ramda";

export const uniqueifyDataByKey = (data: any[], key = "id") =>
	data.filter(Boolean).filter((item, index, arr) => index === arr.findIndex(x => x[key] === item[key]));

export const uniqueifyData = (data: any[]) =>
	data.filter((item, index, arr) => index === arr.findIndex(x => x === item));

export const uniqueifyDataOfObjects = (data: any[]) => uniqWith((a, b) => equals(a, b), data);
